import React, { useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import FilterStatus from './FilterStatus';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHeaders from './TableHeaders';
import TableBody from './TableBody';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import Collapse from '@material-ui/core/Collapse';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import IconButton from '@material-ui/core/IconButton';
import { formatNumber } from '../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: 0,
    paddingRight: 0,
  },
  container: { width: 700, paddingLeft: 0, paddingRight: 0 },
  status: { marginBottom: theme.spacing(1) },
  table: { width: '100%' },
  heading: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    fontWeight: 'bold',
  },
  pastPaymentsSummary: {
    display: 'flex',
    verticalAlign: 'middle',
  },
  pastPaymentsDetails: {
    marginTop: theme.spacing(1),
  },
  splitPaymentsSection: {
    justifyContent: 'center',
  },
  pastPaymentsHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  outstandingText: {
    color: ({ debit }: any) => {
      if (debit === 0) {
        return null;
      } else if (debit > 0) {
        return 'green';
      } else {
        return 'red';
      }
    },
    marginRight: theme.spacing(1),
    fontWeight: 'bold',
  },
  inProcessText: {
    fontWeight: 'bold',
  },
}));

export default function PaymentsTable({
  payments,
  debit = 0,
  onGoingPayments = 0,
  setLoading = null,
  setPayments = null,
  planStatus = null,
  includeFilters = false,
  includeStatus = true,
  splitPaymentTable,
}) {
  const classes = useStyles({ debit });
  const [filterStatus, setFilterStatus] = useState(null);
  const [showPastPayments, setShowPastPayments] = useState(false);
  const pastPayments = payments.filter((payment) =>
    moment(payment.startDate).isSameOrBefore(moment()),
  );
  const futurePayments = payments.filter((payment) =>
    moment(payment.startDate).isAfter(moment()),
  );
  //const outstanding = debit + onGoingPayments;
  return (
    <Container className={classes.root}>
      <div className={classes.container}>
        <div className={classes.status}>
          {includeFilters && (
            <FilterStatus
              onChange={(filter) => {
                setFilterStatus(filter === 'all' ? null : filter);
              }}
              payments={payments}
            />
          )}
        </div>
        {splitPaymentTable && (
          <div className={classes.splitPaymentsSection}>
            <div className={classes.pastPaymentsHeader}>
              <Typography className={classes.heading} variant={'h5'}>
                Past Deliveries & Remittances
              </Typography>
              <IconButton
                color="primary"
                onClick={() => setShowPastPayments(!showPastPayments)}
              >
                {showPastPayments ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </div>
            {(debit !== 0 || onGoingPayments !== 0) && (
              <div className={classes.pastPaymentsSummary}>
                <Typography className={classes.outstandingText}>
                  ${debit !== 0 ? formatNumber(debit) : 0} Outstanding{' '}
                </Typography>
                <Typography className={classes.inProcessText}>
                  (${onGoingPayments !== 0 ? formatNumber(onGoingPayments) : 0}{' '}
                  In Process )
                </Typography>
              </div>
            )}
            <div className={classes.pastPaymentsDetails}>
              <Collapse in={showPastPayments}>
                <TableContainer component={Paper} className={classes.table}>
                  <Table>
                    <TableHeaders includeStatus={includeStatus} />
                    <TableBody
                      payments={
                        filterStatus === null
                          ? pastPayments
                          : pastPayments.filter(
                              (payment) => payment.status === filterStatus,
                            )
                      }
                      includeStatus={includeStatus}
                      setLoading={setLoading}
                      setPayments={setPayments}
                      planStatus={planStatus}
                    />
                  </Table>
                </TableContainer>
              </Collapse>
              <div>
                <Typography className={classes.heading} variant={'h5'}>
                  Upcoming Remittances
                </Typography>
                <TableContainer component={Paper} className={classes.table}>
                  <Table>
                    <TableHeaders includeStatus={includeStatus} />
                    <TableBody
                      payments={
                        filterStatus === null
                          ? futurePayments
                          : futurePayments.filter(
                              (payment) => payment.status === filterStatus,
                            )
                      }
                      includeStatus={includeStatus}
                      setLoading={setLoading}
                      setPayments={setPayments}
                      planStatus={planStatus}
                    />
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        )}
        {!splitPaymentTable && (
          <TableContainer component={Paper} className={classes.table}>
            <Table>
              <TableHeaders includeStatus={includeStatus} />
              <TableBody
                payments={
                  filterStatus === null
                    ? payments
                    : payments.filter(
                        (payment) => payment.status === filterStatus,
                      )
                }
                includeStatus={includeStatus}
                setLoading={setLoading}
                setPayments={setPayments}
                planStatus={planStatus}
              />
            </Table>
          </TableContainer>
        )}
      </div>
    </Container>
  );
}
